<template lang="pug">
  .settings
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('account_settings') }}
        
      div.align-center.justify-center.text-center
        intel-avatar.ma-2(:code="member.user.avatar_code" :id="member.user.id" size=80)
        v-btn.mb-4.px-3.button-AA-tiny(color="info500" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showChangeAvatarDialog = true") {{ $t('change_avatar') }}

      v-form(ref="form")
        v-card.pa-2.px-4.mt-4(flat outlined)
          .label.basic600--text.text-uppercase.mt-3 {{ $t('first_name') }}
          v-text-field.mt-2.s1.basic800--text(dense background-color="basic200" height="40" v-model="form.first_name" type="text" placeholder="First name" outlined :rules="rules.first_name" hide-details="auto")
          .label.basic600--text.text-uppercase.mt-3 {{ $t('last_name') }}
          v-text-field.mt-2.s1.basic800--text(dense background-color="basic200" height="40" v-model="form.last_name" type="text" placeholder="Last name" outlined :rules="rules.last_name" hide-details="auto")
          .label.basic600--text.text-uppercase.mt-3 {{$t('phone.label')}}
          y-phone-input.mt-2(v-model="form.phone")
          .label.basic600--text.text-uppercase.mt-3 {{ $t('your_language') }}
          v-select.mt-2.s1.basic800--text(v-model="language" :items="languages" item-text="name" item-value="code" outlined dense background-color="basic200" height="40" hide-details="auto")
          v-btn.my-4(color='info500' depressed dark block :loading="loading" @click="clickSave")
            div.button-AA-small.white--text {{ $t('update') }}

      v-card.pt-2.pb-4.px-4.mt-4(flat outlined)
        .s1.primary500--text.mt-1(style="") {{ $t('sign_in_methods') }}
        v-row
          v-col.py-0.px-3.grow.pr-0(style="margin-right:-2px" @click="addOrChangePhone")
            v-text-field.mt-4.p1.basic500--text( solo flat background-color="basic200" height="40" color="primary" v-model="user.auth_phone" type="tel" hide-details disabled outlined dense style="border-top-right-radius:0px; border-bottom-right-radius:0px")
              template(v-slot:label)
                .p1.basic600--text {{ $t('phone_number') }}
                v-icon(v-if="user.auth_phone" color="green lighten-1" slot="append") mdi-check-circle
          v-col.pa-0.mt-4.pl-0.pr-3.shrink
            v-btn.info500.button-AA-small.white--text(@click="addOrChangePhone" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ user.auth_phone ? 'Change' : 'Add'}}
        v-row.mt-2
          v-col.py-0.pl-3.grow.pr-0(style="margin-right:-2px")
            v-text-field.mt-4.p1.basic500--text(solo flat background-color="basic200"    height="40" color="primary" v-model="user.email" type="email" label="Email address" hide-details disabled outlined dense style="border-top-right-radius:0px; border-bottom-right-radius:0px")
              template(v-if="user.email")
                v-icon(v-if="user.email_verified" color="green lighten-1" slot="append") mdi-check-circle
                v-icon(v-else color="red lighten-1" slot="append") mdi-close-circle
          v-col.pa-0.mt-4.pr-3.shrink.pl-0
            template(v-if="user.email")
              v-btn.info500.button-AA-small.white--text(height=40 depressed color="accent" @click="verifyOrChangeEmail" style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ user.email_verified ? 'Change' : 'Verify'}}
            template(v-else)
              v-btn.info500.button-AA-small.white--text(height=40 depressed color="accent" @click="addEmail" style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") Add

      v-card.my-4.pa-4(v-if="member && member.id === company.primary_owner" flat outlined)
        .s1.primary-500--text {{ $t('payment_cards') }}
        div.caption.c1.primary400--text.mb-6 {{ $t('add_credit_or_debit') }}
        card-list

      .modal
        change-avatar(v-if="showChangeAvatarDialog" :open.sync="showChangeAvatarDialog" :code.sync="member.user.avatar_code" :user="user.id")
        change-phone(v-if="changePhoneDialog" :showModal.sync="changePhoneDialog")
        verify-email(v-if="verifyEmailDialog" :showModal.sync="verifyEmailDialog" @changeEmail="changeEmail")
        change-email(v-if="changeEmailDialog" :showModal.sync="changeEmailDialog")
        add-email(v-if="addEmailDialog" :showModal.sync="addEmailDialog")
        add-phone(v-if="addPhoneDialog" :showModal.sync="addPhoneDialog")
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import IntelAvatar from '@/components/IntelAvatar.vue'
import ChangeAvatar from '@/components/dialogs/account/ChangeAvatar.vue'
import AddEmail from '@/components/dialogs/account/AddEmail.vue'
import VerifyEmail from '@/components/dialogs/account/VerifyEmail.vue'
import ChangeEmail from '@/components/dialogs/account/ChangeEmail.vue'
import AddPhone from '@/components/dialogs/account/AddPhone.vue'
import ChangePhone from '@/components/dialogs/account/ChangePhone.vue'
import CardList from '@/components/billing/CardList.vue'
import ReferralInfo from '@/components/ReferralInfo'

export default {
  name: 'AccountSettings',
  components: { ReferralInfo, IntelAvatar, ChangeAvatar, CardList, AddEmail, VerifyEmail, ChangeEmail, AddPhone, ChangePhone },
  data: () => ({
    form: {
      first_name: '',
      last_name: '',
      phone: '',
    },
    showChangeAvatarDialog: false,
    addEmailDialog: false,
    verifyEmailDialog: false,
    changeEmailDialog: false,
    addPhoneDialog: false,
    changePhoneDialog: false,
    loading: false,
    language: null,
    languages: [
      { name: 'English', code: 'en' },
      { name: 'Bahasa Indonesia', code: 'id' },
    ],
    rules: {
      first_name: [
        v => !!v || 'First name is required'
      ],
      last_name: [
        v => !!v || 'Last name is required'
      ],
      email: [
        v => !!v || 'E-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      password: [
        v => !!v || 'Password is required'
      ],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ]
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      lang: 'language/getLanguage'
    }),
    ...mapState('user', ['user', 'member']),
    phoneSanitized () {
      let phone = this.form.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
  },
  mounted () {
    this.form.first_name = this.user.first_name
    this.form.last_name = this.user.last_name
    this.form.phone = this.member.phone
    this.language = this.lang
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$axios.patch(`/users/${this.user.id}/`, this.form)
        .then(resp => {
          this.$store.commit('user/setUser', resp.data)
          this.showMessage(['success', this.$t('success_message.profile_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loading = false
        })
      if (this.form.phone) {
        const params = {
          phone: this.phoneSanitized
        }
        this.$axios.patch(`/members/${this.member.id}/`, params)
        .then(resp => {
          this.$store.commit('user/setMember', resp.data)
        })
        .catch(() => {})
      }
      this.$store.commit('language/setLanguage', this.language)
    },
    addOrChangePhone () {
      if (this.user.auth_phone) {
        this.changePhoneDialog = true
      } else {
        this.addPhoneDialog = true
      }
    },
    addEmail () {
      this.addEmailDialog = true
    },
    verifyOrChangeEmail () {
      if (this.user.email_verified) {
        this.changeEmailDialog = true
      } else {
        this.verifyEmailDialog = true
      }
    },
    changeEmail () {
      this.verifyEmailDialog = false
      this.changeEmailDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "account_settings": "Account settings",
    "change_avatar": "Change Avatar",
    "first_name": "First name",
    "last_name": "Last name",
    "phone": {
      "label": "Mobile Phone",
      "placeholder": "Phone Number"
    },
    "update": "Update",
    "sign_in_methods": "Sign in methods",
    "phone_number": "Phone number",
    "payment_cards": "Payment cards",
    "add_credit_or_debit": "Add credit or debit card to pay for subscription and add-ons"
  },
  "id": {
    "account_settings": "Pengaturan Akun",
    "change_avatar": "Ganti Avatar",
    "first_name": "Nama Depan",
    "last_name": "Nama Belakang",
    "phone": {
      "label": "Nomor Telepon",
      "placeholder": "Nomor Telepon"
    },
    "update": "Update",
    "sign_in_methods": "Metode sign-in",
    "phone_number": "Nomor Telepon",
    "payment_cards": "Payment cards",
    "add_credit_or_debit": "Add credit or debit card to pay for subscription and add-ons"
  }
}
</i18n>
